import { modal } from "./modal-instance";

const modalTitle = document.querySelector('[data-request="offer-type"]');
const options = document.querySelectorAll("[data-option]");
const placesInModal = document.querySelector('[data-request="places"]');
const numberOfPlaces = document.querySelector('[data-request="places-count"]');
const pricesInModal = document.querySelector('[data-request="price"]');
const fullPricesInModal = document.querySelector('[data-request="full-price"]');
const oldPriceWrapper = document.querySelector(
    '[data-request="old-price-wrapper"]'
);
const oldFullPriceWrapper = document.querySelector(
    '[data-request="old-full-price-wrapper"]'
);
const oldPrice = document.querySelector('[data-request="old-price"]');
const oldFullPrice = document.querySelector('[data-request="old-full-price"]');
const discount = document.querySelector('[data-request="discount"]');

const dataOptions = {
    basic: "Базовый",
    premium: "Премиум",
    personal: "Персональный",
};

const formatNumber = (number) => {
    return Number(number).toLocaleString('ru-RU')
}

options.forEach((option) => {
    option.addEventListener("click", (e) => {
        const dataset = e.target.dataset;

        modalTitle.textContent = dataOptions[dataset.option];
        placesInModal.style = "display: block;";

        pricesInModal.textContent = 'от ' + formatNumber(dataset.price)
        fullPricesInModal.textContent = 'или ' + formatNumber(dataset.fullPrice)

        if(dataset.discount) {
            discount.style = "display: flex;"
            discount.textContent = dataset.discount
        } else {
            discount.style = "display: none;"
        }

        if (dataset.oldPrice && dataset.discount) {
            oldPriceWrapper.style = "display: block;";

            oldPrice.textContent = formatNumber(dataset.oldPrice)
        } else {
            oldPriceWrapper.style = "display: none;";
        }

        if(dataset.oldFullPrice && dataset.discount) {
            oldFullPriceWrapper.style = "display: block;"
            oldFullPrice.textContent = formatNumber(dataset.oldFullPrice)
        } else {
            oldFullPriceWrapper.style = "display: none;"
        }

        if (dataset.option == "basic") {
            placesInModal.style = "display: none;";
        } else {
            placesInModal.style = "display: block;";
            numberOfPlaces.textContent = dataset.places;
        }
    });
});

export default modal;
